import {
  JourneyElementCommon,
} from '@dapi/sdk';
import {
  createJourneyElement,
  createJourneyElementCommon,
  todayPlusNdays,
} from '@dapi/sdk/spec';
import {
  twoAdtJourneyTravelers,
} from './journeyTraveler';

export const checkedInJourneyElementMultiLeg2ADTWithFreeSeats: JourneyElementCommon[] = [
  createJourneyElementCommon({
    template: {
      journeyElement: createJourneyElement({
        template: {
          checkInStatus: 'accepted',
          traveler: twoAdtJourneyTravelers[0],
          travelerId: twoAdtJourneyTravelers[0].id,
          legs:
            [
              {
                boardPointIataCode: 'NCE',
                offPointIataCode: 'CDG',
                scheduledArrivalDateTime: todayPlusNdays('9:20', 2),
                scheduledDepartureDateTime: todayPlusNdays('9:00', 2),
                seat: {
                  seatNumber: '2A',
                  isInfantOnSeat: false,
                  cabin: 'Y'
                }
              },
              {
                boardPointIataCode: 'CDG',
                offPointIataCode: 'LHR',
                scheduledArrivalDateTime: todayPlusNdays('10:00', 2),
                scheduledDepartureDateTime: todayPlusNdays('9:30', 2),
                seat: {
                  seatNumber: '2A',
                  isInfantOnSeat: false,
                  cabin: 'Y'
                }
              }
            ]
        }
      })
    }
  }),
  createJourneyElementCommon({
    template: {
      journeyElement: createJourneyElement({
        template: {
          checkInStatus: 'accepted',
          traveler: twoAdtJourneyTravelers[1],
          travelerId: twoAdtJourneyTravelers[1].id,
          legs: [
            {
              boardPointIataCode: 'NCE',
              offPointIataCode: 'CDG',
              scheduledArrivalDateTime: todayPlusNdays('9:20', 2),
              scheduledDepartureDateTime: todayPlusNdays('9:00', 2),
              seat: {
                seatNumber: '2B',
                isInfantOnSeat: false,
                cabin: 'Y'
              }
            },
            {
              boardPointIataCode: 'CDG',
              offPointIataCode: 'LHR',
              scheduledArrivalDateTime: todayPlusNdays('10:00', 2),
              scheduledDepartureDateTime: todayPlusNdays('9:30', 2),
              seat: {
                seatNumber: '2B',
                isInfantOnSeat: false,
                cabin: 'Y'
              }
            }
          ]
        }
      })
    }
  })
];
